// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { ObjectInspector, chromeDark } from 'react-inspector';

// Import Material UI
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

// Import Recoil
import { alertState, personalizationState } from '../../../../recoil-store/recoil-state';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Import Icons
import infoIcon from '../../../../assets/icons/info-icon.svg';
import { convertToDateFormat } from '../../../../helpers/helper';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import { Tooltip } from '@material-ui/core';

const OldLogsDetail = ({ log, index, names, img, logType }) => {
    const [expand, setExpand] = useState(false)
    const setAlert = useSetRecoilState(alertState);
    const personalization = useRecoilValue(personalizationState);
    const { t } = useTranslation();
    const label = "MESSAGES.MONITORING."

    const handleChangeExpand = (e, value) => {
        // setExpand(value)
    }
    useEffect(() => {
        if (expand) {
            setExpand(false)
        }
    }, [log])

    const handleExpandRow = (e) => {
        if (e?.target?.localName === "path") {
            if (e.target?.parentElement?.classList) {
                const classList = e.target.parentElement.classList
                if (Object.values(classList)?.includes("log-json-copy-icon")) {
                    return
                }
            }
        }
        if (logType) {
            return
        }
        setExpand((pre) => !pre)
    }

    const customTheme = {
        ...chromeDark, // chromeDark temasını baz al
        BASE_BACKGROUND_COLOR: 'transparent', // Arka plan rengini değiştir
        BASE_COLOR: 'black', // Metin rengini değiştir
        TREENODE_FONT_SIZE: '12px',
        TREENODE_LINE_HEIGHT: '1.5',
        ARROW_COLOR: "#5F5F5F"
    };

    const handleCopy = async (e, text) => {
        try {
            await navigator.clipboard.writeText(text);
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + `COPIED`),
                severity: 'success'
            }));
            e.preventDefault()
            e.stopPropagation()
        } catch (err) {
        }
    };

    return (
        <div className={`log-row-container ${expand ? "bigger-row" : ""} ${log.level?.toLowerCase()}`}>
            <div className="log-row" onClick={(e) => handleExpandRow(e)}>
                <div className='group-column'>
                    <span className='index-number' >{index + 1}.</span>
                    <div className={`log-level-column log-${log.level?.toLowerCase()}`}>{t(label + `${log.level}`).toUpperCase()}</div>
                    <img className='log-action-image' src={img} alt='action-image' />
                    {/* <p>{log.defination}</p> */}
                    <p className='log-action-name' >
                        {log.action_name ? <>
                            {log.label ?
                                <span>{log.label}</span> :
                                <>
                                    <span>
                                        {log.library_label.includes('CUSTOM') ? log.library_name :
                                            t("CONTENT.LIBRARY." + log.library_name + ".NAME")}
                                        {/* {t("CONTENT.LIBRARY." + log.library_name + ".NAME")} */}
                                    </span>
                                    <span className='action-library-name-seperator'> - </span>
                                    <span>
                                        {log?.library_label?.includes('CUSTOM') ? log?.action_name :
                                            t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)}
                                        {/* {t(`CONTENT.LIBRARY.${log.library_name}.ACTION.${log.action_name}`)} */}
                                    </span>
                                </>
                            }

                        </>
                            : logType ? logType : log.level === "TRIGGER-PARAM" ? "" : "-"}
                    </p>
                    {log.level === "TRIGGER-PARAM" && log.text ?
                        <Tooltip title={t(label + `COPY-PAYLOAD`)} placement="bottom" >
                            <FileCopyIcon className='log-json-copy-icon' onClick={(e) => handleCopy(e, log.text)} />
                        </Tooltip>
                        : ""}
                </div>
                {logType ? <p className='time-of-log'>{log?.created_at ? convertToDateFormat(log?.created_at, personalization.date_format) : "-"}</p> : ""}
                {!logType ? !expand ? <ExpandMoreIcon className='expand-collapse-icon' /> : <ExpandLessIcon className='expand-collapse-icon' /> : ""}
            </div>
            {
                expand ?
                    <>
                        <div className='child-log-row first-child-log'>
                            <div className='group-column'>
                                <img className='log-action-image' src={infoIcon} />
                                {log.level === "TRIGGER-PARAM" ? <ObjectInspector data={log.text ? JSON.parse(log.text) : {}} theme={customTheme} />
                                    : <p>{log.text}</p>}
                            </div>
                            <p className='time-of-log'>{log?.created_at ? convertToDateFormat(log?.created_at, personalization.date_format) : "-"}</p>
                        </div>
                    </>
                    : ""
            }
        </div >
    )
}

export default OldLogsDetail